import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const SimpleCardBase = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 32px auto;
  max-width: 500px;
  ${theme.largerThan.lg} {
    max-width: initial;
    margin: 0 40px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Image = styled.div`
  max-height: 159px;
  max-width: 159px;
  margin-bottom: 20px;
  ${theme.largerThan.lg} {
    max-height: 185px;
    max-width: 185px;
  }
`;

export const Title = styled.h3`
  text-align: center;
  color: ${theme.colors.darkBlues["100"]};
  font-weight: 600;
  margin: 0 0 8px 0;
  font-size: 1rem;
  line-height: 1.3125rem;
`;

export const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.darkBlues["90"]};
  text-align: center;
  ${theme.largerThan.lg} {
    max-width: 327px;
  }
`;
